import { render, staticRenderFns } from "./allFilesPreview.vue?vue&type=template&id=883d5922&scoped=true"
import script from "./allFilesPreview.vue?vue&type=script&lang=js"
export * from "./allFilesPreview.vue?vue&type=script&lang=js"
import style0 from "./allFilesPreview.vue?vue&type=style&index=0&id=883d5922&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883d5922",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('883d5922')) {
      api.createRecord('883d5922', component.options)
    } else {
      api.reload('883d5922', component.options)
    }
    module.hot.accept("./allFilesPreview.vue?vue&type=template&id=883d5922&scoped=true", function () {
      api.rerender('883d5922', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wl-business-component/sopComponents/pageFileView/allFilesPreview.vue"
export default component.exports